import React from "react";
import { cn } from "@/lib/utils";

interface PhoneFrameProps {
  children: React.ReactNode;
  className?: string;
  label?: string;
}

/**
 * Minimal device frame used to present in-app screens.
 * Purely presentational — content is passed in.
 */
export const PhoneFrame = ({ children, className, label }: PhoneFrameProps) => (
  <div
    className={cn(
      "relative mx-auto w-full max-w-[280px] aspect-[9/19] rounded-[2.25rem] border border-border bg-background p-2 shadow-soft",
      className
    )}
    role={label ? "img" : undefined}
    aria-label={label}
  >
    <div className="absolute left-1/2 top-2.5 z-10 h-1.5 w-16 -translate-x-1/2 rounded-full bg-foreground/10" />
    <div className="h-full w-full overflow-hidden rounded-[1.75rem] bg-paper">{children}</div>
  </div>
);

export default PhoneFrame;
